/* One renderer for real block finds. Data comes only from btc-reward-live.js. */
(function () {
  'use strict';
  if (window.__bmBlockCards) return;
  window.__bmBlockCards = true;
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    var list = root.querySelector('[data-bm-block-items]');
    var more = root.querySelector('[data-bm-block-more]');
    var received = false;
    function node(tag, cls, text) {
      var el = document.createElement(tag);
      el.className = cls;
      if (text != null) el.textContent = text;
      return el;
    }
    function card(block) {
      var fmt = window.BMFormat;
      var link = node('a', 'bm-win-card');
      link.href = fmt.mempool('block/' + block.height);
      link.target = '_blank';
      link.rel = 'noopener nofollow';
      var icon = node('span', 'bm-win-icon');
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3h8v5a4 4 0 0 1-8 0V3Z M8 5H4v2a4 4 0 0 0 4 4 M16 5h4v2a4 4 0 0 1-4 4 M12 12v6 M8 21h8 M9 18h6v3"/></svg>';
      var info = node('div', 'bm-win-info');
      var top = node('div', 'bm-win-topline');
      top.append(node('span', 'bm-win-height', 'Block #' + fmt.int(block.height)), node('span', 'bm-win-pool', block.pool || '—'));
      var meta = node('div', 'bm-win-meta');
      meta.append(node('span', '', fmt.date(block.timestamp)), node('span', '', '· ' + fmt.timeAgo(block.timestamp)));
      info.append(top, meta);
      var value = node('div', 'bm-win-value');
      value.append(node('div', 'bm-win-eur', fmt.eur(block.eurValue)));
      if (Number.isFinite(Number(block.rewardBtc)) && Number(block.rewardBtc) > 0) {
        value.append(node('div', 'bm-win-btc', Number(block.rewardBtc).toLocaleString(document.documentElement.lang || 'de', { maximumFractionDigits: 8 }) + ' BTC'));
      }
      link.append(icon, info, value);
      return link;
    }
    function render(data) {
      if (!window.BMFormat || !data || !Array.isArray(data.blocks)) return;
      var valid = data.blocks.filter(function (b) {
        return b && Number.isSafeInteger(b.height) && b.height > 0 && Number.isFinite(b.timestamp) && b.timestamp > 0 && Number.isFinite(b.eurValue) && b.eurValue >= 0;
      });
      if (!valid.length) return; // Keep the last good snapshot on an invalid refresh.
      var shown = valid.slice(0, 6);
      var fragment = document.createDocumentFragment();
      shown.forEach(function (block) { fragment.appendChild(card(block)); });
      list.replaceChildren(fragment);
      received = true;
      var total = data.stats && Number.isFinite(data.stats.totalBlocks) ? Math.max(valid.length, data.stats.totalBlocks) : valid.length;
      var count = root.dataset.countId && document.getElementById(root.dataset.countId);
      if (count) count.textContent = shown.length + root.dataset.countOf + total + root.dataset.countSuffix;
      if (root.dataset.moreCopy && total > shown.length) {
        more.innerHTML = root.dataset.moreCopy.replace('{count}', window.BMFormat.int(total - shown.length)).replace('{url}', window.BMFormat.mempool(''));
        more.hidden = false;
      } else more.hidden = true;
    }
    render(window.bmRewardData);
    document.addEventListener('bm:reward-loaded', function (event) { render(event.detail); });
    setTimeout(function () {
      if (received || !root.isConnected) return;
      var error = root.querySelector('[data-bm-block-error]');
      if (error) list.replaceChildren(error.content.cloneNode(true));
      var count = root.dataset.countId && document.getElementById(root.dataset.countId);
      if (count) count.textContent = '—';
    }, 12000);
  }
  function init() { document.querySelectorAll('[data-bm-block-cards]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
